/* eslint-disable @typescript-eslint/naming-convention */
// list our application constants here
// this is a simple plugin that allows us to use them like:
// console.log(Vue.Constants.API_PATH)

import { PluginObject } from 'vue'
import { ICON } from 'vue/types/vue'
import STATE_ISO_MAP from './states'
import DEGREE_ENUM_MAP from './degrees'
import MONTH_ENUM_MAP from './months'

// TODO - do we need constants as a plugin?
const Constants: PluginObject<any> = {
  install (Vue, options: any) {
    Vue.Constants = {
      API_PATH: process.env.VUE_APP_API_PATH || 'http://localhost:4000',
      TIMEZONES: [
        { name: 'HAWAII', value: 'HAWAII' },
        { name: 'ALASKA', value: 'ALASKA' },
        { name: 'PACIFIC', value: 'PACIFIC' },
        { name: 'MOUNTAIN', value: 'MOUNTAIN' },
        { name: 'CENTRAL', value: 'CENTRAL' },
        { name: 'EASTERN', value: 'EASTERN' },
        { name: 'ATLANTIC', value: 'ATLANTIC' }
      ],
      // TODO: Replace options with actual values
      TOPICS: [
        { name: 'Technology', value: 'Technology' },
        { name: 'Health Care', value: 'Health Care' }
      ],
      // TODO: Replace options with actual values
      JOBS: [
        { name: '(selected job)' }
      ],
      STATE_ISO_MAP,
      DEGREE_ENUM_MAP,
      MONTH_ENUM_MAP,
      // TODO: Replace options with actual values
      INCOME: [
        { name: '$0-$15,000' },
        { name: '$15,000-$35,000' },
        { name: '$35,000-$60,000' },
        { name: '$60,000-$90,000' },
        { name: '$90,000-$135,000' }
      ],
      // TODO: Replace options with actual values
      MAJORS: [
        { name: 'Health Care Administration' },
        { name: 'Registered Nurse' }
      ],
      // TODO: Replace options with actual values
      RANGE_LARGE: [
        { name: '0-500' },
        { name: '500-1,000' },
        { name: '1,000-1,500' },
        { name: '2,000-3,000' },
        { name: '3,000-5,000' }
      ],
      NUMBERS_SEQ: [
        { name: '0', value: 0 },
        { name: '1', value: 1 },
        { name: '2', value: 2 },
        { name: '3', value: 3 },
        { name: '4', value: 4 },
        { name: '5', value: 5 },
        { name: '6', value: 6 },
        { name: '7', value: 7 },
        { name: '8', value: 8 },
        { name: '9', value: 9 },
        { name: '10', value: 10 },
        { name: '15', value: 15 },
        { name: '20', value: 20 }
      ],
      // TODO: Replace options with actual values
      YEARS: [
        { name: '1900' },
        { name: '1950' },
        { name: '2000' },
        { name: '2001' },
        { name: '2002' },
        { name: '2003' },
        { name: '2004' },
        { name: '2005' },
        { name: '2006' },
        { name: '2007' },
        { name: '2008' },
        { name: '2009' },
        { name: '2010' },
        { name: '2011' },
        { name: '2012' },
        { name: '2013' },
        { name: '2014' },
        { name: '2015' },
        { name: '2016' },
        { name: '2017' },
        { name: '2018' },
        { name: '2019' },
        { name: '2020' },
        { name: '2021' }
      ],
      DISTANCES: [
        { name: 'Within 5 miles', value: 5 },
        { name: 'Within 10 miles', value: 10 },
        { name: 'Within 15 miles', value: 15 },
        { name: 'Within 25 miles', value: 25 },
        { name: 'Within 50 miles', value: 50 },
        { name: 'Within 100 miles', value: 100 },
      ],
      LEARNER_SORT_OPTIONS: [
        { name: 'Skills Match' },
        { name: 'Completion Date' },
        { name: 'Number of Badges' }
      ],
      SOCIAL_ICONS: {
        TWITTER: 'link',
        INSTAGRAM: 'link'
      }
    }
  }
}

export const MapSocialIcon = (url: string, main = false): ICON => {
  if (main) return 'stay_current_portrait'
  const domain = url.split('www.').pop()?.split('/')[0].split('.com')[0] // get only domain
  // TODO: Add additional icons
  switch (domain) {
    case 'twitter':
    case 'instagram':
    default:
      return 'link'
  }
}

export default Constants
